import StoreHelper from '../store/helper'
import CalculationHelper from './CalculationHelper'
import DomHelper from './DomHelper'
import StyleConverter from './StyleConverter'

const PositionManager = class PositionManager {
  /* Drag element position */
  static recalculateDragElementPositions (elements) {
    elements.forEach(PositionManager.calculateDragElementPosition)
  }

  static calculateDragElementPosition (el, index) {
    if (el.isPlaceholder) return

    const position = PositionManager._getDragItemPosition(index)
    DomHelper.applyStyleToElement(el, StyleConverter.createMenuItemTransformation(position))
  }

  static _getDragItemPosition (index, offset = 0) {
    const rotationAngle = CalculationHelper.calculateRotation(StoreHelper.getDefaultAngle(), index) + offset
    const distanceToCenter = StoreHelper.getDistanceToCenter()

    return { rotation: rotationAngle, distanceToCenter: distanceToCenter }
  }

  /* Drop target position */
  static recalculateDropTargetPositions () {
    StoreHelper.getDropTargets().forEach(PositionManager.calculateDropTargetPosition)
  }

  static calculateDropTargetPosition (el, index) {
    const offset = StoreHelper.isAfterDropTarget(index) ? 0 : -StoreHelper.getDefaultAngle()
    const expanded = StoreHelper.isDropTarget(el)
    let position = PositionManager.getDropTargetPosition(index, offset, expanded)

    DomHelper.applyStyleToElement(el, StyleConverter.createDropTargetTransformation(position))
  }

  static getDropTargetPosition (index, offset = 0, expanded = false) {
    const rotationAngle = CalculationHelper.calculateRotation(StoreHelper.getDefaultAngle(), index) + offset

    if (expanded) {
      return {
        rotation: rotationAngle,
        skewY: CalculationHelper.calculateExpandedSkewY(StoreHelper.getDefaultAngle(), 5)
      }
    }

    return {
      rotation: rotationAngle,
      skewY: CalculationHelper.calculateSkewY(StoreHelper.getDefaultAngle())
    }
  }

  /* Drop target indicator position */
  static calculateDropIndicatorPosition (index, offset = 0) {
    return PositionManager._getDragItemPosition(index, offset)
  }

  /* Position helper */
  static getPositionConsideringPagination (position) {
    return StoreHelper.getPaginationPage() * StoreHelper.getMaxItemsPerPage() + position
  }
}

export default PositionManager
